import { type AnalyticsServiceType } from "@/services/analytics";
import { buildQueryString, fuseBaseServiceUrl } from "@/services/endpoint-urls";

export type OAuthServiceType = {
  ensureToken(mondayAppClientId: string, mondaySessionToken: string, mondayAccountSlug: string): Promise<boolean>;
  token: string;
};

export async function fetchToken(sessionToken: string): Promise<string> {
  const fuseBaseUrl = fuseBaseServiceUrl();
  const headers = new Headers();
  const appKey = import.meta.env.VITE_MONDAY_APP_KEY as string;
  headers.append("Authorization", sessionToken);
  headers.append("appkey", appKey);
  const response = await fetch(`${fuseBaseUrl}/sharedapi/utils/1.1/accesstoken?productType=monday`, { headers });
  if (response.ok) {
    return await response.text();
  } else {
    return "";
  }
}

export class OAuthService implements OAuthServiceType {
  #token = "";

  constructor(private readonly analytics: AnalyticsServiceType) {}

  public get token() {
    return this.#token;
  }

  async ensureToken(mondayAppClientId: string, mondaySessionToken: string, mondayAccountSlug: string) {
    if (this.#token) {
      return true;
    }
    const token = await fetchToken(mondaySessionToken);
    if (token) {
      this.#token = token;
      return true;
    }
    await this.redirectUserToOAuthExchangePage(mondayAppClientId, mondaySessionToken, mondayAccountSlug);
    return false;
  }

  private async redirectUserToOAuthExchangePage(
    mondayAppClientId: string,
    mondaySessionToken: string,
    mondayAccountSlug: string
  ) {
    // Need to await the delivery of the event prior to redirecting/reloading the page.
    await this.analytics.sendPageViewedEvent("authorization");
    // TODO: Find a way to assert this is set; if not it's a build/env config issue
    const redirectUri = import.meta.env.VITE_OAUTH_REDIRECT_URL || "INVALID";
    const state = encodeURIComponent(
      JSON.stringify({
        token: mondaySessionToken,
        redirectUri: redirectUri,
        redirectPath: window.location.href,
      })
    );
    const queryString = buildQueryString({
      client_id: mondayAppClientId,
      redirect_uri: redirectUri,
      subdomain: mondayAccountSlug,
      state: state,
    });
    window.location.href = `https://auth.monday.com/oauth2/authorize?${queryString}`;
  }
}
